import React from 'react';

import { useParams } from 'react-router-dom';

import { useSelector } from 'react-redux';

import { IXOneCapture } from './components/ixone-section/IXOneCapture';
import { RibbonButton } from 'common/components';

import { IXOneProvider } from './components/ixone-credit-card/IXOneContext';

import { useVisibleModal } from 'hooks';
import { useCheckCreditCardPermission } from 'hooks/useCheckCreditCardPermission';

import selectorsGridView from 'common/components/grid-view/controllers/selectors';

import IX_One_Logo2285 from 'assets/IX_One_Logo2285.png';

import { toArray } from 'utils/array';

import './IXOneSection.less';

const IXOneSection = ({ width, isDetailView = false, ...otherProps }) => {
  const [visibleModal, { onModal, offModal }] = useVisibleModal();

  const { canPayViaCreditCard: hasPermissionIXOneCapture } =
    useCheckCreditCardPermission();

  const { id: productId } = useParams();

  const selectProductGrid =
    useSelector(selectorsGridView.makeSelectDetailCurrentITemsSelection()) ??
    [];

  const selectedProductIdsGrid =
    selectProductGrid?.map((product) => parseInt(product?.id)) ?? [];

  const initialProductIds = isDetailView
    ? toArray(parseInt(productId))
    : selectedProductIdsGrid;

  return (
    <>
      <RibbonButton
        icon={
          <img
            src={IX_One_Logo2285}
            alt='IX-ONE Capture'
            style={{ width, background: '#ffffff' }}
          />
        }
        onClick={onModal}
        {...otherProps}
        disabled={!hasPermissionIXOneCapture}
      />
      {visibleModal && (
        <IXOneProvider productIds={initialProductIds}>
          <IXOneCapture
            visible={visibleModal}
            onCancel={offModal}
            productId={productId}
            isDetailView={isDetailView}
          />
        </IXOneProvider>
      )}
    </>
  );
};

export default IXOneSection;
